export default __webpack_public_path__ + "static/media/dailyreflection-btn.c370b82a.png";